import * as React from 'react';
import classnames from 'classnames';
import styles from './SocialButton.scss';
var typeTexts = {
  vk: 'вконтакте',
  facebook: 'facebook',
  telegram: 'telegram',
  twitter: 'twitter',
  youtube: 'youtube',
  instagram: 'instagram'
};

function SocialButton(_ref) {
  var type = _ref.type,
      href = _ref.href,
      target = _ref.target,
      children = _ref.children,
      onClick = _ref.onClick;
  var isLink = Boolean(href);
  return React.createElement(isLink ? 'a' : 'button', {
    type: !isLink ? 'button' : undefined,
    href: href,
    target: target,
    className: classnames(styles.socialButton, styles[type]),
    onClick: onClick
  }, children || typeTexts[type]);
}

SocialButton.defaultProps = {
  href: null,
  target: null,
  children: null,
  onClick: undefined
};
export default SocialButton;